import React, { useEffect, useMemo, useState } from "react";
import { UrlApi } from "../../../../services/apirest";
import DataImpuestos from "./componentes_data/DataImpuestos";
import DataProveedores from "./componentes_data/DataProveedores";
import DataImputaciones from "./componentes_data/DataImputaciones";
import {
    Stepper,
    Box,
    StepLabel,
    StepButton,
    Step
} from '@mui/material';
import { handleguardarCambios, handleRechazarProveedor } from "./funciones";
import { idsEmpresasDesdeProveedor } from "./unidadesNegocioUtils";
import Notify from "../../../Notify";
import Title from '../../../TitleUploaded';
import moment from "moment";


export default function FormRevisar(props) {
    const dataRevision = useMemo(() => {
        const raw = props.data || props.row;
        if (!raw || typeof raw !== "object") return raw;
        const { coeficiente, vigencia, vigencia_date, ...resto } = raw;
        return resto;
    }, [props.data, props.row]);

    const [datosFormulario, setdatosFormulario] = useState({
        nro_cuit: props.data?.nro_cuit || null,
        correos_por_area: Array.isArray(props.data?.correos_por_area) ? props.data.correos_por_area : [],
        acepta_echeq: props.data?.acepta_echeq ?? 0,
        otras_unidades_negocio: props.data?.otras_unidades_negocio ?? 0,
        unidades_negocio: Array.isArray(props.data?.unidades_negocio) ? props.data.unidades_negocio : [],
    });
    //aca guardo las operaciones del proveedor. Como puede ser más de uno lo guardo en un estado distinto.
    //uuid_proveedor/id_operacion/operacion_otros/
    const [operacionesSeleccionadas, setOperacionesSeleccionadas] = useState([]);
    const [operacionesProveedor, setoperacionesProveedor] = useState([]);
    const [empresasSeleccionadas, setEmpresasSeleccionadas] = useState(
        () => idsEmpresasDesdeProveedor(props.data)
    );
    const [provincias, setProvincias] = useState([]);
    const [operacionOtros, setOperacionOtros] = useState("");
    const [iibbpadrones, setiibbpadrones] = useState([]);
    const [documentos, setDocumentos] = useState([]);
    const [activeStep, setActiveStep] = useState(0);
    const [imageUrl, setImageUrl] = useState("");
    const [imputacionesSeleccionadas, setImputacionesSeleccionadas] = useState([])
    const steps = ["Datos Generales", "Impuestos", "Imputaciones"];
    const [openClose, setopenClose] = useState(false);
    const [openPreview, setOpenPreview] = useState(false);

    useEffect(() => {
        const dataInicial = props.data;


        if (dataInicial) {
            setdatosFormulario({
                // ...dataInicial,
                nro_cuit: dataInicial.nro_cuit,
                razon_social: dataInicial.razon_social,
                nombre_fantasia: dataInicial.nombre_fantasia,
                direccion: dataInicial.direccion,
                id_pais: dataInicial.id_pais,
                id_moneda: dataInicial.id_moneda,
                sisven_id: dataInicial.sisven_id,
                autogas_id: dataInicial.autogas_id,
                telefono: dataInicial.telefono,
                email: dataInicial.email,
                nombre_contacto: dataInicial.nombre_contacto,
                id_actividadprincipal: dataInicial.id_actividadprincipal,
                id_actividadsecundaria: dataInicial.id_actividadsecundaria,
                id_condicioniva: dataInicial.id_condicioniva,
                id_convenio: dataInicial.id_convenio,
                id_banco: dataInicial.id_banco,
                cbu: dataInicial.cbu,
                exclusion: dataInicial.exclusion,
                vto_exclusion: moment(dataInicial.vto_exclusion).format("YYYY-MM-DD"),
                usuario: localStorage.getItem('user'),
                pais: dataInicial.pais,
                banco: dataInicial.banco,
                convenio: dataInicial.convenio,
                condicion: dataInicial.condicion,
                correos_por_area: Array.isArray(dataInicial.correos_por_area)
                    ? dataInicial.correos_por_area
                    : [],
                acepta_echeq: dataInicial.acepta_echeq ?? 0,
                otras_unidades_negocio: dataInicial.otras_unidades_negocio ?? 0,
                unidades_negocio: Array.isArray(dataInicial.unidades_negocio)
                    ? dataInicial.unidades_negocio
                    : [],
            });
            setEmpresasSeleccionadas(idsEmpresasDesdeProveedor(dataInicial));
        }
    }, [props.data,]);

    // console.log("props.datos", props.data);


    const [notify, setNotify] = useState({
        open: false,
        mensaje: "",
        severity: "success",
        color: "",
    });

    const getDataPadrones = async () => {
        await fetch(`${UrlApi}/iibb_proveedores/alliibb/${props.data.nro_cuit}`)
            .then((data) => data.json())
            .then((data) => setiibbpadrones(data))
    };

    const getAdjuntos = async () => {
        await fetch(`${UrlApi}/proveedores/x/archivos/${props.data.nro_cuit}`)
            .then((data) => data.json())
            .then((data) => setDocumentos(data))
    };


    const getProvincias = async () => {
        await fetch(`${UrlApi}/provincias/iibbmanual`)
            .then((data) => data.json())
            .then((data) => setProvincias(data))
    };

    const getOperacionesProveedor = async () => {
        try {
            const response = await fetch(`${UrlApi}/proveedores/a/operaciones/${props.data.nro_cuit}`);
            const data = await response.json();
            const operaciones = Array.isArray(data) ? data : [];
            setoperacionesProveedor(operaciones);
            setOperacionesSeleccionadas(operaciones);
        } catch (error) {
            console.error("Error obteniendo operaciones:", error);
            setoperacionesProveedor([]);
        }
    };

    useEffect(() => {
        getAdjuntos()
        getProvincias()
    }, []);

    React.useEffect(() => {
        //una vez que se ingresa el nro de cuit, busco la data del padron
        if (props.data.nro_cuit) {
            getDataPadrones()
            getOperacionesProveedor()

        }
    }, [props.data.nro_cuit]);

    const handleAlmacenarDatos = (e) => {
        const { name, value } = e.target;

        setdatosFormulario({
            ...datosFormulario,
            [name]: value === "" ? null : value,
        });

    };

    const handleStep = (step) => () => {
        setActiveStep(step);
    };

    const ViewFiles = async (archivo, mime) => {
        console.log("archivo", archivo);

        let response;

        if (mime === "application/pdf") {
            response = await fetch(`${UrlApi}/uploadfiles/uploadspdf/${archivo}`);
        } else {
            response = await fetch(`${UrlApi}/uploadfiles/uploads/${archivo}`);
        }

        const blob = await response.blob();
        const url = URL.createObjectURL(blob);

        setImageUrl(url);
        setOpenPreview(true); // 
    };

    useEffect(() => {
        if (openPreview && imageUrl) {
            window.open(imageUrl, "_blank", "noreferrer");
            setOpenPreview(false); // 🔥 clave
        }
    }, [openPreview, imageUrl]);

    const handleGuardarClick = async (areaAprobacion) => {
        const resultado = await handleguardarCambios({
            datosFormulario: {
                id_moneda: datosFormulario.id_moneda,
                sisven_id: datosFormulario.sisven_id,
                autogas_id: datosFormulario.autogas_id,
                nro_cuit: datosFormulario.nro_cuit
            },
            imputacionesSeleccionadas,
            empresasSeleccionadas,
            accion: 1,
            area_aprobacion: areaAprobacion,
            setNotify
        });
        if (resultado?.ok && typeof props.actualizar === "function") {
            props.actualizar();
        }
    };

    const handleRechazarClick = async (motivoRechazo) => {
        const resultado = await handleRechazarProveedor({
            nro_cuit: datosFormulario.nro_cuit,
            motivo: motivoRechazo,
            setNotify,
        });
        if (resultado?.ok === true && typeof props.actualizar === "function") {
            props.actualizar();
        }
        return resultado?.ok === true;
    };

    const handleClose = () => {
        props.setopen(false)
        props.tabla(true)
        props.actualizar()
    };

    //ACA VOYT A GUARDAR TODAS LAS PROPIEDADES QUE LE PASO A LOS OTROS COMPONENTES
    const propiedades = {
        datos: datosFormulario,
        setDatos: setdatosFormulario,
        documentos: documentos,
        handleAlmacenarDatos: handleAlmacenarDatos,
        ViewFiles: ViewFiles,
        imageUrl: imageUrl,
        openClose: openClose,
        setopenClose: setopenClose,
        editar: 0,
        // abrirGestorAdjunto: abrirGestorAdjunto,
        // archivoActual: archivoActual,
        operacionesSeleccionadas: operacionesSeleccionadas,
        setOperacionesSeleccionadas: setOperacionesSeleccionadas,
        operacionesProveedor: operacionesProveedor,
        operacionOtros: operacionOtros,
        setOperacionOtros: setOperacionOtros,
        iibbpadrones: iibbpadrones,
        step: activeStep,
        imputacionesSeleccionadas: imputacionesSeleccionadas,
        setImputacionesSeleccionadas: setImputacionesSeleccionadas,
        notify: notify,
        data: dataRevision,
        handleGuardarClick: handleGuardarClick,
        handleRechazarClick: handleRechazarClick,
        empresasSeleccionadas: empresasSeleccionadas,
        setEmpresasSeleccionadas: setEmpresasSeleccionadas,
        provincias: provincias,
        revisado_compras: Number(dataRevision?.revisado_compras) === 1,
        revisado_impuestos: Number(dataRevision?.revisado_impuestos) === 1,
    };

    return (
        <div>
            <Title title={`Habilitar proveedor ${props.data?.razon_social || datosFormulario.razon_social || ''}`} pt={2} handleClose={handleClose} />
            <Box sx={{ width: "100%", maxWidth: "100%", minWidth: 0, mt: 3 }}>
                <Stepper activeStep={activeStep} nonLinear sx={{ mt: -2, mb: 2 }}>
                    {steps.map((label, index) => (
                        <Step key={label}>
                            <StepButton onClick={handleStep(index)}>
                                <StepLabel
                                    StepIconProps={{
                                        sx: {
                                            color: index === activeStep ? "#1976d2" : "grey.400",
                                            fontSize: "2rem",
                                        },
                                    }}
                                    sx={{
                                        "& .MuiStepLabel-label": {
                                            fontWeight: index === activeStep ? "bold" : "normal",
                                            color: index === activeStep ? "#1976d2" : "text.secondary",
                                        },
                                    }}
                                >
                                    {label}
                                </StepLabel>
                            </StepButton>
                        </Step>
                    ))}
                </Stepper>
            </Box>
            {activeStep === 0 ?
                <DataProveedores
                    {...propiedades}
                />
                : null}
            {activeStep === 1 ?
                <DataImpuestos
                    {...propiedades}
                />

                : null}
            {activeStep === 2 ?
                <DataImputaciones
                    {...propiedades}
                />
                : null}

            {notify.open && (
                <Notify
                    open={notify.open}
                    mensaje={notify.mensaje}
                    severity={notify.severity}
                    color={notify.color}
                    handleClose={() => {
                        handleClose();
                    }}
                    duracion={1500}
                />
            )}
        </div>
    );
}
